import { createApp } from 'vue'
import Exponent from './Exponent.vue'
import './assets/global.css'

createApp(Exponent).mount('#exponent')
